import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Banner } from 'Shared/util/types';
import { useTranslation } from 'Shared/util/custom-hooks';
import add from 'date-fns/add';
import BaseBanner from 'Shared/components/banners/base-banner';
import Description from 'Shared/components/description';
import InputCheckbox from 'Shared/components/input-checkbox';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import styles from './fortnox-banner.css';


const FortnoxBanner = () => {
  const [declineChecked, setDeclineChecked] = useState(false);
  const history = useHistory();
  const t = useTranslation(x => x.fortnox.banner);
  const tg = useTranslation(x => x.global);

  const handleToggleDeclineChecked = () => {
    setDeclineChecked((prev) => !prev);
  };

  return (
    <BaseBanner
      id={Banner.Fortnox}
      render={(renderProps) => (
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <h2>{t.simplify_administration}</h2>
            <InlineSvg src="/integration/fortnox.svg" className={styles.logoSvgContainer} />
          </div>
          <Description
            text={t.sell_and_follow_up}
            className={styles.description}
          />
          <InlineSvg src="/pile-of-money.svg" className={styles.illustrationSvgContainer} />
          <div className={styles.actionContainer}>
            <Button
              text={declineChecked ? tg.save : tg.readMore}
              className={styles.button}
              buttonType="action-primary"
              onClick={() => declineChecked
                ? renderProps.hide(add(new Date(), { months: 2 }))
                : history.push('/sales-methods/fortnox-setup')
              }
            />
            <InputCheckbox
              label={tg.noThanksImNotIntrested}
              checked={declineChecked}
              onChange={handleToggleDeclineChecked}
              className={styles.checkbox}
              classNameLabel={styles.checkboxLabel}
            />
          </div>
        </div>
      )}
    />
  );
};

export default FortnoxBanner;
